var React = require('react');

function User (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 21C1.33123 15 3.74737 12 8.24842 12C12.7495 12 15 15 15 21M8 12C11.0376 12 13.5 9.53757 13.5 6.5C13.5 3.46243 11.0376 1 8 1C4.96243 1 2.5 3.46243 2.5 6.5C2.5 9.53757 4.96243 12 8 12Z","stroke":"#382E2B","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

User.defaultProps = {"width":"16","height":"22","viewBox":"0 0 16 22","fill":"none"};

module.exports = User;

User.default = User;
